import React from 'react';

import { Block } from '../common/Block.jsx';
import { Numeric, Required, Text } from '../common/Input.jsx';
import { TabSelectionDropDown } from '../common/Tab.jsx';
import Utilities from '../common/Utilities.jsx';

// region INPUT

function InputComponent(props) {
    const [id, setId] = React.useState(undefined);
    React.useEffect(() => setId(Utilities.generateUniqueId()), []);
    const [currentState, setCurrentState] = React.useState('empty');
    const inputProps = {};
    if (props.onInputProps) {
        props.onInputProps({ blockConfig: props.blockConfig, type: props.blockConfig.block.type }, inputProps);
    }
    if (inputProps.hidden) {
        return null;
    }
    const placeholderStyle = {};
    let placeholderClassName = 'input__placeholder';
    let typeStyle = 'p';
    let containerStyle, percentageWidth, placeholderText;
    if (props.blockConfig) {
        if (props.blockConfig.block) {
            if (inputProps.placeholderText) {
                placeholderText = `<p>${inputProps.placeholderText}</p>`;
            }
            inputProps.style = {};
            Block.mapStyleConfigProps(inputProps.style, props.blockConfig.block, (propName, propValue) => {
                switch (propName) {
                    case 'design':
                        if (propValue) {
                            typeStyle = Utilities.moveTokenStyle(propValue, inputProps.style);
                        }
                        return true;
                    case 'placeholder':
                        if (id && !Utilities.isHTMLContentEmpty(propValue)) {
                            placeholderText = propValue;
                        }
                        return true;
                    case 'required':
                        inputProps.required = propValue;
                        return true;
                    case 'resize':
                        if (propValue == false) {
                            inputProps.style.resize = 'none';
                        }
                        return true;
                    case 'rows':
                        if (propValue) {
                            inputProps.rows = propValue;
                        }
                        return true;
                    case 'type':
                        return true;
                }
            })
        }
        if (props.blockConfig.layout) {
            if (!inputProps.style) {
                inputProps.style = {};
            }
            Block.mapStyleConfigProps(inputProps.style, props.blockConfig.layout, (propName, propValue, propUnit) => {
                switch (propName) {
                    case 'alignment':
                        inputProps.style.display = 'block';
                        inputProps.style.margin = Block.marginForAlignment(propValue);

                        switch (propValue) {
                            case 'left':
                                placeholderClassName += ' input__placeholder--left';
                                break;
                            case 'right':
                                placeholderClassName += ' input__placeholder--right';
                                break;
                            default:
                                placeholderClassName += ' input__placeholder--center';
                                break;
                        }
                        return true;
                    case 'marginBottom':
                    case 'marginLeft':
                    case 'marginRight':
                    case 'marginTop':
                        let _propValue = propValue;
                        if (_propValue && propUnit) {
                            _propValue = `${_propValue}${propUnit}`;
                        }
                        if (_propValue) {
                            if (!containerStyle) {
                                containerStyle = {};
                            }
                            containerStyle[propName] = _propValue;
                        }
                        return true;
                    case 'paddingBottom':
                    case 'paddingLeft':
                    case 'paddingRight':
                    case 'paddingTop':
                        if (propValue && propUnit) {
                            placeholderStyle[propName] = `${propValue}${propUnit}`;
                        }
                        break;
                    case 'width':
                        if (!props.inLayout && propValue && propUnit) {
                            placeholderStyle[propName] = `${propValue}${propUnit}`;
                        }
                        if (props.inLayout && propValue && propUnit == '%') {
                            // Inputs inside layout containers with percentage width need to be handled differently
                            percentageWidth = `${propValue}${propUnit}`
                            return true;
                        }
                        break;
                }
            });
        }
    }
    for (let id in inputProps.style) {
        switch (id) {
            case 'borderBottomWidth':
            case 'borderLeftWidth':
            case 'borderRightWidth':
            case 'borderTopWidth':
            case 'borderBottomStyle':
            case 'borderLeftStyle':
            case 'borderRightStyle':
            case 'borderTopStyle':
                placeholderStyle[id] = inputProps.style[id];
                break;
        }
    }
    if (percentageWidth) {
        inputProps.style.width = '100%';

        if (!containerStyle) {
            containerStyle = {};
        }
        if (props.builder) {
            // When in builder, buttons inside layout containers with percentage widths apply margins and width to the builder container 
            containerStyle.marginLeft = undefined;
            containerStyle.marginRight = undefined;
            containerStyle.width = '100%';
        } else {
            // Buttons inside layout containers with percentage widths need to apply the width at the top most level so the calculation is correct
            containerStyle.width = percentageWidth;
        }
    }
    let className = 'input--whitelabel richText';
    if (props.className) {
        className += ` ${props.className}`;
    }
    if (inputProps.wrapperClassName) {
        className += ` ${inputProps.wrapperClassName}`;
    }
    if (inputProps.errors && inputProps.errors[inputProps.name]) {
        className += ' input--error';
    }
    if (props.builder) {
        if (!props.disabled) {
            className += ' input--builder';
        }
        if (currentState == 'sample') {
            inputProps.value = 'Sample Text';
        }
        if (props.editor) {
            inputProps.style.pointerEvents = 'none';
        }
    }
    let Component;
    switch (props.type) {
        case 'numeric':
            Component = Numeric;
            break;
        default:
            Component = inputProps.required != false ? Required : Text
            break;
    }
    if (inputProps.className) {
        inputProps.className += ` ${typeStyle}`;
    } else {
        inputProps.className = typeStyle;
    }
    if (!inputProps.onChange) {
        inputProps.onChange = () => {};
    }
    return (
        <>
            {
                props.builder &&
                !props.disabled &&
                <TabSelectionDropDown
                    label="STATE"
                    tab={currentState}
                    onBlockMove={props.onBlockMove}
                    onSelect={setCurrentState}>
                    <option value={'empty'}>Empty</option>
                    <option value={'sample'}>Sample Text</option>
                </TabSelectionDropDown>
            }
            <div className={className} style={containerStyle}>
                {
                    (!inputProps.value || inputProps.value.length == 0) &&
                    placeholderText &&
                    <div className={placeholderClassName} style={placeholderStyle} dangerouslySetInnerHTML={{ __html: placeholderText }} />
                }
                <Component {...inputProps} />
                {inputProps.extras}
            </div>
        </>
    )
}
export default { Component: InputComponent };